import { Expose } from 'class-transformer'
import { IsDefined } from 'class-validator'
import { League } from '../../entity'

export class ListLeaguesDTO {

    @Expose()
    @IsDefined()
    leagues!: League[]


}

